import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Box,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/PharmsmartIcon/SearchIcon.svg";
import { ReactComponent as AddIcon } from "../../Assets/Icons/PharmsmartIcon/AddIcon.svg";
import { ReactComponent as ActivityLog } from "Assets/Icons/ActivityLogs.svg";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import { useNavigate } from "react-router-dom";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { connect } from "react-redux";
import {
  START_GET_STAFF_LIST,
  START_DELETE_STAFF,
  RESET_STAFF_STATE,
} from "../../Actions/StaffAction";
import { useIntersection } from "../../Hooks/customHooks";
import _ from "underscore";
import {
  getClearObject,
  getLocalStorage,
  setLocalStorage,
  getNewOrder,
} from "../../utils/generalUtils";
import "../../Sass/Common.scss";
import StaffTable from "./StaffTable";
import clsx from "clsx";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import TableColumnShowMenu from "../Common/Table/TableColumnShowMenu";
import { ReactComponent as SettingIcon } from "../../Assets/Icons/PharmsmartIcon/SettingsIcon.svg";
import HtmlTooltip from "../../Components/Common/HtmlTooltipMain";
import useViewport from "../../Hooks/useViewport";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import { useSelector } from "react-redux";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { GridOff } from "@mui/icons-material";
const CreateStaffDialog = React.lazy(() =>
  import("../../Components/Staff/CreateStaffDialog")
);
const ConfirmationDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ConfirmationDialog")
);

/** head title */
const tableCells = {
  name: {
    id: "name",
    label: "STAFF NAME",
    sortable: true,
    show: true,
    showValue: false,
  },
  email: {
    id: "email",
    label: "EMAIL",
    sortable: true,
    show: true,
    showValue: true,
  },
  dob: {
    id: "dob",
    label: "DOB",
    sortable: true,
    show: true,
    showValue: true,
  },
  role: {
    id: "role",
    label: "ROLE",
    sortable: true,
    show: true,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    showValue: false,
  },
};

const useStyle = makeStyles((theme) => ({
  rsSurgeriesLeftHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 6px",
    background: "#333",
    "&>button": {
      height: "37px !important",
      marginLeft: "5px",
    },
    "&>div": {
      height: "37px !important",
    },
    "&>div": {
      "&>div": {
        "&>div": {
          // height: "37px !important",
        },
      },
      "&>button": {
        height: "37px !important",
        marginLeft: "10px",
        marginRight: "10px",
        [theme.breakpoints.down("768")]: {
          marginLeft: "0px",
        },
      },
    },
    // "&>div": {
    // [theme.breakpoints.down("768")]: {
    //   display: "block",
    //   "&>div": {
    //     marginTop: "5px !important",
    //   },
    // },
    // },
  },
  activityBtn: {
    "&>span": {
      "&>svg": {
        "&>g": {
          "&>path": {
            fill: `${theme.palette.primary.main} !important`,
          },
        },
      },
    },
    [theme.breakpoints.down("405")]: {
      width: "200px",
    },
  },
  managePageHMob: {
    "& .MuiTableContainer-root": {
      padding: "0px !important",
      [theme.breakpoints.down("975")]: {
        maxHeight: "calc(100vh - 220px) !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              lineHeight: "1.2rem",
              padding: "11px 16px",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                // left: "0px",
                zIndex: 4,
              },
              " &:nth-child(2)": {
                position: "sticky",
                borderLeft: "none !important",
                // left: 0,
                zIndex: 1,
                // right: "0px",
              },
              " &:nth-child(4)": {
                position: "sticky",
                // left: 0,
                zIndex: 1,
                // right: "0px",
              },
              "&:last-child": {
                position: "sticky",
                // right: "0px",
                padding: "0 10px !important",
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "relative",
                // left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                background: "#ffffff",
                position: "relative",
                // left: 0,
                zIndex: 0,
                // right: "0px",
              },
              " &:nth-child(4)": {
                background: "#ffffff",
                position: "relative",
                // left: 0,
                zIndex: 1,
                zIndex: 0,
                // right: "0px",
              },
              "&:last-child": {
                background: "#ffffff",
                position: "relative",
                // right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  managePageH: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(96vh - 148px) !important",
      // maxHeight: "calc(98vh - 200px) !important",
      // padding: "13px !important",
      // [theme.breakpoints.down(1400)]: {
      //   maxHeight: "calc(97vh - 203px) !important",
      // },
      padding: "0px !important",
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              lineHeight: "1.2rem",
              padding: "11px 16px",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "0px",
                zIndex: 4,
              },
              " &:nth-child(2)": {
                position: "sticky",
                left: 0,
                zIndex: 1,
                right: "0px",
                borderLeft: "none !important",
              },
              " &:nth-child(4)": {
                position: "sticky",
                left: 0,
                zIndex: 1,
                right: "0px",
              },
              "&:last-child": {
                position: "sticky",
                right: "0px",
                padding: "0 10px !important",
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 0,
                right: "0px",
                borderLeft: "none !important",
              },
              " &:nth-child(4)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
                zIndex: 0,
                right: "0px",
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  globalSettingIcon: {
    // margin: "-11px 0 10px",
    margin: "0 7px 0px",
  },
  rsGrid: {
    [theme.breakpoints.down(769)]: {
      padding: "5px !important",
    },
  },
  rsSetting: {
    [theme.breakpoints.down(769)]: {
      paddingRight: "18px !important",
    },
  },
  rsSearchMob: {
    marginBottom: "0",
    marginRight: "5px",
    [theme.breakpoints.down(976)]: {
      marginRight: "0px !important",
    },
    [theme.breakpoints.down(769)]: {
      marginTop: "0px !important",
      "&>div": {
        marginTop: "0px !important",
        width: "200px",
      },
    },
    [theme.breakpoints.down(364)]: {
      marginTop: "0px !important",
      "&>div": {
        marginTop: "0px !important",
        width: "140px",
      },
    },
  },
  resActivity: {
    height: "37px !important",
  },
  rsSearchMobbutton: {
    // [theme.breakpoints.down(405)]: {
    //   justifyContent: "start",
    //   paddingTop: "20px",
    //   "&>button": {
    //     width: "200px",
    //     marginLeft: "18px",
    //   },
    // },
  },
  rsMainMarign: {
    [theme.breakpoints.down(768)]: {
      marginTop: "0px !important",
    },
  },
  search: {
    marginTop: "0px !important",
    height: "37px !important",
    "&>div": {
      height: "37px !important",
    },
  },
  rsButtonHowtoIcon: {
    // background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    [theme.breakpoints.down(976)]: {
      height: "37px !important",
    },
    "&>span": {
      marginLeft: "-8px",
    },
    "&>svg": {
      "&>path": {
        fill: "white !important",
      },
    },
  },
  rsTable: {
    position: "relative",
    clear: "both",
    // marginTop: "5px"
  },
  resHeader: {
    display: "flex !important",
    flexDirection: "column !important",
    width: "100%",
    "&>div": {
      display: "flex !important",
      flexDirection: "row !important",
      justifyContent: "space-between",
      width: "100%",
    },
    "&>div:nth-child(1)": {
      marginBottom: "5px",
    },
  },
}));

const StaffsMain = (props) => {
  const classes = useStyle();
  const {
    getStaffListAction,
    staffList,
    deleteStaffAction,
    deleteStaffData,
    resetStaffState,
  } = props;
  const [addsStaff, setAddStaff] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [staffDeleteId, setStaffDeleteId] = useState("");
  const [deleteStaff, setDeleteStaff] = useState(false);
  const [editStaffData, setEditStaffData] = useState({});
  const [updateStaffPassword, setUpdateStaffPassword] = useState([]);
  const [staffRecordActionType, setStaffRecordActionType] = useState("");
  const staffListRecordLimit = 20;
  const defaultColumnOrderBy = "asc";
  const { width } = useViewport();
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "",
  });
  const [driver, setDriver] = useState("");
  const navigate = useNavigate();
  const [openTableColumn, setOpenTableColumn] = useState(false);
  const [columnsPopperAnchorEl, setColumnsPopperAnchorEl] = useState(null);
  const [tableColumns, setTableColumns] = useState({});
  const activeColumns = getLocalStorage("dynamicColumnStaff")?.split(",") || [];
  const columnSequence =
    getLocalStorage("dynamicColumnSequenceStaff")?.split(",") || [];
  const loginUserDetail = useSelector((state) => state.user);
  const [subscriptionDialog, setSubscritionDialog] = useState(false);

  /* Staff main api Function */
  const getList = (params = {}) => {
    let payload = {
      offset: 0,
      limit: staffListRecordLimit,
      q: searchValue,
      order_by: params.orderBy || columnSortingOrder.orderBy,
      sort_by: (params.sortBy || columnSortingOrder.sortBy).toUpperCase(),
    };

    payload = {
      ...payload,
      ...params,
    };
    getStaffListAction(getClearObject(payload));
  };
  useEffect(() => {
    let payload = {
      offset: 0,
      limit: 20,
    };
    if (getLocalStorage("urlstaff") == "staff") {
      getStaffListAction(payload);
      setLocalStorage("urlstaff", "none");
    } else {
      getStaffListAction(payload);
    }
    return () => {
      if (window.location.pathname !== "/staff") {
        // getStaffListAction(payload);
        // window.onbeforeunload = null;
        // setLocalStorage("pharmacyChange", false);
      }
    };
  }, []);
  /* Pagination useEffect */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (staffList?.data?.list?.length != staffList?.data?.filterd_record) {
        getList({
          offset: staffList?.data?.list?.length,
          limit: staffListRecordLimit,
          order_by: columnSortingOrder.orderBy,
          sort_by: columnSortingOrder.sortBy.toUpperCase(),
        });
      }
    }
  }, [entry]);

  /* Staff search debounce useRef */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );

  /* Handle Search Staff Function */
  const handleSearch = (newValue) => {
    searchUserDebounce.current(newValue, {
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
    });
  };

  /* Handle Delete Staff Member Function */
  const handleDeleteStaffMember = () => {
    // if (loginUserDetail?.loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    deleteStaffAction(staffDeleteId);
    // }
  };

  /* Delete Loading useEffect */
  useEffect(() => {
    if (
      !deleteStaffData?.loading &&
      Object.keys(deleteStaffData?.data)?.length
    ) {
      setDeleteStaff(false);
      setStaffDeleteId("");
      resetStaffState("deleteStaffData", "");
    }
  }, [deleteStaffData]);
  useEffect(() => {
    if (columnSortingOrder.orderBy && columnSortingOrder.sortBy) {
      getList();
    }
  }, [columnSortingOrder.orderBy, columnSortingOrder.sortBy]);
  /* Detect column order changes */
  // useEffect(() => {
  //   getList();
  // }, [columnSortingOrder]);

  //Set value after page refresh useEffect
  useLayoutEffect(() => {
    let allColumns = tableCells;

    if (activeColumns.length > 0) {
      Object.keys(allColumns)?.map((key) => {
        if (allColumns[key].showValue) {
          if (activeColumns.indexOf(allColumns[key].id) !== -1) {
            allColumns[key].show = true;
          } else {
            allColumns[key].show = false;
          }
        }
      });
    }
    allColumns = getNewOrder(columnSequence, allColumns);
    setTableColumns(allColumns);
  }, []);

  return (
    <>
      <Grid className={classes.rsMainMarign}>
        <Grid className={classes.rsSurgeriesLeftHeader}>
          {/* <HtmlTooltipMain title="Create Staff" className="hoverAlign">
            <IconButton
              className={clsx("btn_green", classes.rsButtonHowtoIcon)}
              variant="contained"
              onClick={() => {
                setStaffRecordActionType("createNewStaff");
                setAddStaff(true);
              }}
            >
              <GroupAddIcon width="20px" cursor="pointer" />
            </IconButton>
          </HtmlTooltipMain> */}

          {width >= 975 && (
            <>
              <Button
                className={classes.rsButtonHowtoIcon}
                variant="contained"
                startIcon={
                  <PrimaryIcon
                    icon={AddIcon}
                    color="white"
                    width="16px"
                    height="16px"
                  />
                }
                onClick={() => {
                  setStaffRecordActionType("createNewStaff");
                  setAddStaff(true);
                }}
              >
                Create Staff
              </Button>
              <Grid className={clsx("rsHeader", classes.rsSearchMob)}>
                {/* <Grid className="rsHeader"> */}
                <TextField
                  withPadding={true}
                  medium
                  secondary
                  className={classes.search}
                  placeholder="Search..."
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e?.target?.value);
                    handleSearch(e?.target?.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <>
                        <InputAdornment position="end">
                          <PrimaryIcon width="20px" icon={SearchIcon} />
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
                <Button
                  className="btn_green"
                  variant="outlined"
                  startIcon={
                    <PrimaryIcon
                      icon={ActivityLog}
                      color="white"
                      width="16px"
                      height="16px"
                    />
                  }
                  onClick={() => {
                    navigate(`/staff?actionType=activity`);
                  }}
                >
                  Activity Log
                </Button>
                {/* <Button
                className="btn_green"
                variant="outlined"
                startIcon={
                  <PrimaryIcon
                    icon={AddIcon}
                    color="white"
                    width="16px"
                    height="16px"
                  />
                }
                onClick={() => {
                  setStaffRecordActionType("createNewStaff");
                  setAddStaff(true);
                }}
              >
                Create Staff
              </Button> */}

                {/* <Box className="RsSetting">
                <HtmlTooltip title="Setting">
                  <Box>
                    <PrimaryIcon
                      color="secondary"
                      className={classes.globalSettingIcon}
                      width="20px"
                      icon={SettingIcon}
                      cursor="pointer"
                      onClick={() => {
                        setStaffRecordActionType("staffDragDrop");
                        setOpenTableColumn(true);
                      }}
                    />
                  </Box>
                </HtmlTooltip>
              </Box> */}
                <Box
                  className="ColumnMain"
                  onClick={(e) => {
                    setColumnsPopperAnchorEl(e.currentTarget);
                    setStaffRecordActionType("staffDragDrop");
                    setOpenTableColumn(true);
                  }}
                >
                  <HtmlTooltip title="Columns">
                    <Box>
                      <Button
                        className="ColumnBtn"
                        // onClick={() => {
                        //   setStaffRecordActionType("staffDragDrop");
                        //   setOpenTableColumn(true);
                        // }}
                      >
                        <PrimaryIcon
                          color="black"
                          width="20px"
                          icon={ViewWeekIcon}
                          cursor="pointer"
                        />
                        Columns
                        <PrimaryIcon
                          color="black"
                          width="30px"
                          icon={ArrowDropDownIcon}
                          cursor="pointer"
                        />
                      </Button>
                    </Box>
                  </HtmlTooltip>
                </Box>
              </Grid>
            </>
          )}

          {width < 975 && (
            <Grid className={classes.resHeader}>
              <Grid>
                <Button
                  className={classes.rsButtonHowtoIcon}
                  variant="contained"
                  startIcon={
                    <PrimaryIcon
                      icon={AddIcon}
                      color="white"
                      width="16px"
                      height="16px"
                    />
                  }
                  onClick={() => {
                    setStaffRecordActionType("createNewStaff");
                    setAddStaff(true);
                  }}
                >
                  Create Staff
                </Button>
                <Grid className={clsx("rsHeader", classes.rsSearchMob)}>
                  {/* <Grid className="rsHeader"> */}
                  <TextField
                    withPadding={true}
                    medium
                    secondary
                    className={classes.search}
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e?.target?.value);
                      handleSearch(e?.target?.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <>
                          <InputAdornment position="end">
                            <PrimaryIcon width="20px" icon={SearchIcon} />
                          </InputAdornment>
                        </>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid>
                <Button
                  className={clsx(classes.resActivity, "btn_green")}
                  variant="outlined"
                  startIcon={
                    <PrimaryIcon
                      icon={ActivityLog}
                      color="white"
                      width="16px"
                      height="16px"
                    />
                  }
                  onClick={() => {
                    navigate(`/staff?actionType=activity`);
                  }}
                >
                  Activity Log
                </Button>
                <Box
                  className="ColumnMain"
                  onClick={(e) => {
                    setColumnsPopperAnchorEl(e.currentTarget);
                    setStaffRecordActionType("staffDragDrop");
                    setOpenTableColumn(true);
                  }}
                >
                  <HtmlTooltip title="Columns">
                    <Box>
                      <Button
                        className="ColumnBtn"
                        // onClick={() => {
                        //   setStaffRecordActionType("staffDragDrop");
                        //   setOpenTableColumn(true);
                        // }}
                      >
                        <PrimaryIcon
                          color="black"
                          width="20px"
                          icon={ViewWeekIcon}
                          cursor="pointer"
                        />
                        Columns
                        <PrimaryIcon
                          color="black"
                          width="30px"
                          icon={ArrowDropDownIcon}
                          cursor="pointer"
                        />
                      </Button>
                    </Box>
                  </HtmlTooltip>
                </Box>
              </Grid>
            </Grid>
          )}

          {/* {width < 786 && (
            <>
              <Grid className={clsx(classes.rsSearchMobbutton)}>
                <Button
                  variant="outlined"
                  startIcon={
                    <PrimaryIcon
                      icon={AddIcon}
                      color="primary"
                      width="16px"
                      height="16px"
                    />
                  }
                  onClick={() => {
                    setStaffRecordActionType("createNewStaff");
                    setAddStaff(true);
                  }}
                >
                  Create Staff
                </Button>
              </Grid>
              <Grid className={clsx(classes.rsSearchMob)}>
                <TextField
                  withPadding={true}
                  medium
                  secondary
                  placeholder="Search..."
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e?.target?.value);
                    handleSearch(e?.target?.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <>
                        <InputAdornment position="end">
                          <PrimaryIcon width="20px" icon={SearchIcon} />
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              </Grid>
              <Box className="ColumnMain">
                <HtmlTooltip title="Columns">
                  <Box>
                    <Button
                      className="ColumnBtn"
                      onClick={() => {
                        setStaffRecordActionType("staffDragDrop");
                        setOpenTableColumn(true);
                      }}
                    >
                      <PrimaryIcon
                        color="black"
                        width="20px"
                        icon={ViewWeekIcon}
                        cursor="pointer"
                      />
                      Columns
                      <PrimaryIcon
                        color="black"
                        width="30px"
                        icon={ArrowDropDownIcon}
                        cursor="pointer"
                      />
                    </Button>
                  </Box>
                </HtmlTooltip>
              </Box>
            </>
          )} */}
        </Grid>

        <Box className={classes.rsGrid}>
          <Grid
            className={clsx(
              classes.rsTable,
              width <= 1000 ? classes.managePageHMob : classes.managePageH
            )}
          >
            {/* <Grid className={clsx("common-table", classes.managePageH)}> */}
            <StaffTable
              setTarget={setTarget}
              columnSortingOrder={columnSortingOrder}
              defaultColumnOrderBy={defaultColumnOrderBy}
              staffList={staffList}
              setStaffRecordActionType={setStaffRecordActionType}
              setEditStaffData={setEditStaffData}
              setAddStaff={setAddStaff}
              setDeleteStaff={setDeleteStaff}
              setStaffDeleteId={setStaffDeleteId}
              setDriver={setDriver}
              setUpdateStaffPassword={setUpdateStaffPassword}
              setColumnSortingOrder={setColumnSortingOrder}
              tableCells={tableColumns}
            />
          </Grid>
        </Box>
      </Grid>
      <CreateStaffDialog
        open={addsStaff}
        staffRecordActionType={staffRecordActionType}
        setOpen={setAddStaff}
        editData={editStaffData}
        setEditData={setEditStaffData}
        updatePassword={updateStaffPassword}
        setUpdatePassword={setEditStaffData}
        getList={getList}
      />
      <ConfirmationDialog
        open={deleteStaff}
        setOpen={setDeleteStaff}
        subTitle={`${
          driver > 0
            ? `This driver cannot be deleted as it is assigned in ${driver} ${
                driver > 1 ? "surgeries" : "surgery"
              }.`
            : ""
        }`}
        title="Are you sure?"
        body="You wan't be able to undo this staff!"
        actionBtnTitle="Yes Delete It!!"
        handleSubmit={handleDeleteStaffMember}
        loading={deleteStaffData?.loading}
      />
      <TableColumnShowMenu
        open={openTableColumn}
        setOpen={setOpenTableColumn}
        tableColumns={tableColumns}
        anchorEl={columnsPopperAnchorEl}
        setTableColumns={setTableColumns}
        onOrderChange={(newOrder) => setTableColumns(newOrder)}
        tableCells={tableCells}
        staffRecordActionType={staffRecordActionType}
        moduleName={"staff"}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  staffList: state.staff.staffList,
  deleteStaffData: state.staff.deleteStaffData,
});
const mapDispatchToProps = (dispatch) => ({
  getStaffListAction: (payload) =>
    dispatch({ type: START_GET_STAFF_LIST, payload }),
  deleteStaffAction: (id) => dispatch({ type: START_DELETE_STAFF, id }),
  resetStaffState: (key, payload) =>
    dispatch({ type: RESET_STAFF_STATE, key, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffsMain);
